const APP_NAME = 'BuffaloBossMM';

let deferredPrompt = null;
let listenersBound = false;

export function bindPwaInstallEvents() {
  if (typeof window === 'undefined' || listenersBound) {
    return;
  }
  listenersBound = true;

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
  });
}

export function isPwaInstalled() {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export async function installPwaApp() {
  bindPwaInstallEvents();

  if (isPwaInstalled()) {
    return { outcome: 'already-installed' };
  }

  if (deferredPrompt) {
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    deferredPrompt = null;
    return { outcome: choice.outcome };
  }

  const ua = window.navigator.userAgent || '';
  if (/iphone|ipad|ipod/i.test(ua)) {
    return { outcome: 'ios-instructions' };
  }
  if (/android/i.test(ua)) {
    return { outcome: 'android-instructions' };
  }
  return { outcome: 'unavailable' };
}

export function getPwaInstallMessage(outcome, language) {
  const isEn = language === 'en';
  if (outcome === 'already-installed') {
    return isEn
      ? 'BuffaloBossMM is already installed on this device.'
      : 'BuffaloBossMM ကို ဤစက်တွင် ထည့်သွင်းပြီးဖြစ်ပါသည်။';
  }
  if (outcome === 'ios-instructions') {
    return isEn
      ? 'Tap Share, then Add to Home Screen to install BuffaloBossMM.'
      : 'Share ကိုနှိပ်ပြီး Add to Home Screen ဖြင့် BuffaloBossMM ကို ထည့်သွင်းပါ။';
  }
  if (outcome === 'android-instructions' || outcome === 'unavailable') {
    return isEn
      ? 'Open the browser menu and tap Install app to add BuffaloBossMM.'
      : 'ဘရောက်ဇာ menu မှ Install app ကိုနှိပ်ပြီး BuffaloBossMM ကို ထည့်သွင်းပါ။';
  }
  return null;
}

export { APP_NAME };
